// extracted by mini-css-extract-plugin
module.exports = {"section":"KanBoPicker_section__10ntu"};